import React, { useState } from "react";
import "./Footer.css";
import { FbLogo, InstaLogo, Logo2, XLogo } from "../../images/Images";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__footer">
        <div className="footer__brand">
          <div className="footer__logo">
            <img src={Logo2} alt="logo" />
          </div>
          <div className="footer__social">
            <a
              href="https://www.instagram.com/pamundo.llc/profilecard/?igsh=Mmx0ejZsYWdodmNt"
              target="_blank"
            >
              <img src={InstaLogo} alt="instagram logo" />
            </a>
            <a href="/" target="_blank">
              <img src={FbLogo} alt="fb logo" />
            </a>

            <a href="https://www.linkedin.com/company/pamundo/" target="_blank">
              <img src={XLogo} alt="X logo" />
            </a>
          </div>
        </div>
        <div className="footer__links">
          <a href="#">Term of use</a> |{" "}
          <a href="/privacy-policy">Privacy Policy</a>
        </div>
        <p>©2024 Pamundo All Rights Reserved</p>
      </div>
    </div>
  );
};

export default Footer;
